import React, { useEffect } from "react";
import { Link } from "react-router-dom";

//import drawer
import "react-drawer/lib/react-drawer.css";

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

//import images
import logoSvg from "../../assets/images/logo-sm.jpeg";
import logoSvgSM from "../../assets/images/logo-sm-fix.jpg";

import "./styles.scss";

const Header = (props: any) => {
  /**
   * Toggle sidebar
   */
  const toggleMenu = () => {
    if (document.body.className !== "") {
      document.body.classList.remove("sidebar-enable");
    } else {
      document.body.classList.add("sidebar-enable");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSvgSM} alt="" height="auto" width="40" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg} alt="" height="auto" width="150" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSvgSM} alt="" height="auto" width="40" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg} alt="" height="auto" width="150" />
                </span>
              </Link>
            </div>

            <button
              onClick={() => {
                toggleMenu();
              }}
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item mobile"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
